module.exports = __webpack_public_path__ + "static/img/home-tel.9691d886.png";